import { GroupVatModelType } from '@teinor/erp/types/company/vat/groupVat'
import { useLocation } from 'react-router-dom'
import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import ModalCEGroupVat from './ModalCEGroupVat'
import { TwinTableLink } from '../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { EditRow } from '../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'

interface ConfigGroupVatsProps extends ComponentWithPermissions { }

const ConfigGroupVats: React.FC<ConfigGroupVatsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('groupVats', 'Grupos de impuestos'),
        newText: t('createNewGroup', 'Crear nuevo grupo')
    }

    return (
        <BaseScreenTable TableComponent={ConfigGroupVatsTable} CreateModalComponent={ModalCEGroupVat} EditModalComponent={ModalCEGroupVat} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface ConfigGroupVatsTableProps extends TableComponentProps { }

const ConfigGroupVatsTable: React.FC<ConfigGroupVatsTableProps> = ({ setTableInstance, setOpened }) => {
    const { t } = useTwinTranslation()
    const location = useLocation().pathname
    const columns: ColumnTableSchema<GroupVatModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
            width: 100
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            minWidth: 130,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData, e) => { e.preventDefault(); e.stopPropagation(); setOpened({ type: 'edit', allRowData }) }} />
        },
    ]
    return (
        <TwinTableLink name='groupVats' columns={columns} getDataFrom='/api/app/config/vat/getAllGroupsVat' createRowDataLink={[location, ['$id']]} defaultOrder={{ order: 'asc' }} setTableInstance={setTableInstance}
        />
    )
}


export default ConfigGroupVats